<div class="row row-overlay">
  <!-- <app-blast-design-informations
    [class]="isInformationsCollapsed() ? 'col-md-1' : 'col-md-4'"
    [blast]="blast()"
    [tirId]="tirId()"
    [qualityData]="qualityData()"
    [selectedHoleId]="holeSelected()"
    (addHole)="onAddHole()"
    (holeSelected)="onHoleSelected($event)"
    (collapseChanged)="onCollapseChanged($event)"
    >
  </app-blast-design-informations> -->
  @if (blast() && qualityData()) {
    <app-blast-design-data
      class="col-md-6"
      [blast]="blast()"
      [qualityData]="qualityData()"
      [selectedHoleId]="holeSelected()"
      (holeSelected)="onHoleSelected($event)"
      >
    </app-blast-design-data>
  }
  @if (blast() && !qualityData()) {
    <div class="col-md-6 d-flex align-items-center justify-content-center">
      <div class="alert alert-warning text-center" role="alert">
        <i class="fa fa-exclamation-triangle mr-2"></i>
        {{ 'GLOBAL.HOLE_TOLERANCE_NOT_CONFIRMED' | translate }}
      </div>
    </div>
  }

  @if (blast() && blast().BlastDesign) {
    <app-holes-list-data [ngClass]="{ 'row': !qualityData(), 'col-md-6': qualityData() }" [blast]="blast()" [holes]="blast().BlastDesign" [selectedHoleId]="holeSelected()" (holeSelected)="onHoleSelected($event)" (addHole)="onAddHole()"></app-holes-list-data>
  }
</div>

